import axios from "axios";
import Auth from "./services/api/Auth";
import { setCookie } from "./services/Common";

axios.interceptors.request.use(
    function (config) {
        let token = localStorage.getItem("access-token");
        let client = localStorage.getItem("client");
        let uid = localStorage.getItem("uid");

        config.headers["access-token"] = token;
        config.headers["client"] = client;
        config.headers["uid"] = uid;

        return config;
    },
    function (err) {
        return Promise.reject(err);
    }
);

axios.interceptors.response.use(
    function (response) {
        let { headers } = response;
        if (headers["access-token"]) {
            localStorage.setItem("access-token", headers["access-token"]);
        }
        return response;
    },
    function (error) {
        if (typeof error.response === "undefined") {
            return Promise.reject(error);
        }
        if (error.response.config.url.search("admin_auth/sign_in") !== -1) {
            return Promise.reject(error);
        }

        if (
            error.response.config.url.search("api/orders") !== -1 &&
            error.response.config.url.search("fresh=true") !== -1
        ) {
            return Promise.reject(error);
        }

        if (error.response.status === 401) {
            localStorage.setItem("error_logout", 1);
            Auth.logOut();
            window.location.reload();
        }

        if (error.response.status === 403) {
            localStorage.setItem("error_denied", 1);
            window.location.assign("/#/denied");
        }

        if (error.response.status === 406) {
            window.location.reload();
        }
        return Promise.reject(error);
    }
);



// WEBPACK FOOTER //
// ./src/AxiosInterceptor.js